export default __webpack_public_path__ + "static/media/ChickenFingers.171340d0.jpg";